/*
 * Screen detector. Runs once at start-up and again whenever the window changes (resize, rotate, phone address bar
 * showing / hiding). It writes three things on <html> so any style or component can adapt without its own listener:
 *
 *   data-screen   "phone" (<640) | "tablet" (<1024) | "laptop" (<1440) | "desktop" (<2200) | "wide"
 *   data-orient   "portrait" | "landscape"
 *   --navi-vh     1% of the REAL visible height in px (100vh is wrong on phones while the address bar is showing)
 *   --navi-vw     1% of the visible width in px, without the scrollbar
 *
 * The layout itself is fluid CSS (see navi-fluid.css) and does not depend on this file; this only adds the labels + vh fix.
 */
const BREAKS = [[640, "phone"], [1024, "tablet"], [1440, "laptop"], [2200, "desktop"]];

function measure() {
  const root = document.documentElement;
  const vv = window.visualViewport;
  const w = Math.round(root.clientWidth || window.innerWidth);
  const h = Math.round((vv && vv.height) || window.innerHeight);
  const label = (BREAKS.find(([max]) => w < max) || [0, "wide"])[1];
  if (root.dataset.screen !== label) root.dataset.screen = label;
  const orient = w > h ? "landscape" : "portrait";
  if (root.dataset.orient !== orient) root.dataset.orient = orient;
  root.style.setProperty("--navi-vh", `${h / 100}px`);
  root.style.setProperty("--navi-vw", `${w / 100}px`);
}

let raf = 0;
const schedule = () => { if (!raf) raf = window.requestAnimationFrame(() => { raf = 0; measure(); }); };

export function initScreenDetector() {
  if (typeof window === "undefined" || typeof document === "undefined" || window.__naviScreenWired) return;
  window.__naviScreenWired = true;
  measure();
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("orientationchange", schedule, { passive: true });
  window.visualViewport?.addEventListener("resize", schedule, { passive: true });
}
